<template>
  <el-drawer
    title="资料下载"
    :visible.sync="drawerVisible"
    direction="btt"
    size="72%"
    :wrapperClosable="true"
    :close-on-press-escape="false"
    @close="closeDrawer"
  >
    <div v-show="!fileList.length" class="blank-box">暂无数据</div>
    <div v-show="fileList.length" class="file-download-container">
      <div class="file-item" v-for="(item, index) in fileList" :key="index">
        <div class="file-left"></div>
        <div class="file-center">
          {{ item.title }}
        </div>
        <div class="file-right" @click="downloadHandle(item)"></div>
      </div>
    </div>
  </el-drawer>
</template>
<script>

export default {
  name: "fileDownload",
  props: {
    //drawer 是否展示
    visible: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      drawerVisible: false,
    }
  },
  watch: {
    visible(newVal) {
      this.drawerVisible = newVal
    }
  },
  methods: {
    downloadHandle(item) {
      let name = ''
      fetch(item.url).then(response => {
        let fileStrArr = response.url.split('/')
        let fileStr = fileStrArr[fileStrArr.length-1]
        name = decodeURIComponent(fileStr)
        return response.blob()
      }).then(blob => {
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.style.display = "none"; // 使其隐藏
        a.href = url;
        a.download = name;
        a.click();

        URL.revokeObjectURL(url);
      });
    },
    // 关闭弹窗
    closeDrawer() {
      this.$emit('closeDrawer', 'files')
    },
  }
}
</script>
<style lang="scss" scoped>
.file-download-container{
  margin-top: 20rem;

  .file-item{
    width: 702rem;
    min-height: 181rem;
    background: #FFFFFF;
    padding: 50rem 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1rem dashed #E3E3E3;

    &:last-child{
      border: 0;
    }

    .file-left{
      flex: 0 0 80rem;
      height: 80rem;
      background: url(~@/assets/images/common/file-item-icon.png) center top no-repeat;
      background-size: cover;
      margin-right: 22rem;
    }
    .file-center{
      flex: 1;
      margin-right: 64rem;
      font-size: 32rem;
      line-height: 42rem;
      color: #333;
    }

    .file-right{
      flex: 0 0 48rem;
      height: 48rem;
      background: url("~@/assets/images/common/file-download-icon.png") center top no-repeat;
      background-size: cover;
      margin-right: 4rem;
      cursor: pointer;
    }
  }
}
.blank-box {
  margin: 180rem auto 60rem;
  padding-top: 30%;
  font-size: 28rem;
  text-align: center;
  color: #a5b3c6;
  width: 450rem;
  height: 300rem;
  background: url("~@/assets/images/common/blank_pic.png") center center no-repeat;
  background-size: contain;
}
/deep/.el-drawer{
  border-radius: 20rem 20rem 0 0;

  .el-drawer__header{
    padding: 0 42rem 0 32rem;
    margin: 0;
    border-bottom: 2rem solid #E3E3E3;

    span{
      font-size: 36rem;
      color: #333;
      font-weight: bold;
      line-height: 112rem;
    }

    .el-drawer__close-btn{
      font-size: 36rem;
    }
  }
}
</style>